<script setup lang="ts">
import { ref } from "vue";
import { DbInput } from "@db-ui/v-elements-enterprise/dist/components";
const input = ref("");
defineProps({
  type: {
    type: String,
    default: "text",
    required: false,
  },
  modelValue: {
    default: "",
  },
  placeholder: {
    default: "",
  },
  disabled: {
    default: false,
  },
  errorMessage: {
    type: String,
    default: undefined,
    required: false,
  },
  name: {
    default: "",
    required: false,
  },
  label: {
    default: "",
    required: false,
  },
  ariainvalid: {
    type: String as () =>
      | "false"
      | "grammar"
      | "spelling"
      | "true"
      | undefined
      | "",
    default: "false",
    required: false,
  },
});
</script>
<template>
  <div class="flex flex-col">
    <db-input
      :type="type"
      :label="label"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="modelValue"
      variant="semitransparent"
      @input="$emit('update:modelValue', $event.target.value)"
      ref="input"
      :ariainvalid="ariainvalid"
    ></db-input>
    <span v-if="errorMessage"
      ><p class="showError" v-html="errorMessage"></p
    ></span>
  </div>
</template>
<style scoped>
.default-input-class {
  margin-top: 0px;
}

.showError {
  color: #ec0016;
}
</style>
